















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import TemplateManager from './components/TemplateManager.vue';
import NotificationHooksManager from './components/NotificationHooksManager.vue';
import NotificationSettings from './components/NotificationSettings.vue';

@Component({
    components: {
        TemplateManager,
        NotificationHooksManager,
        NotificationSettings
    }
})
export default class PushNotificationManager extends Vue {
    // Data
    tab = null;
}
